import { Modal, notification, Row, Space } from 'antd';
import { AlignType } from 'rc-table/lib/interface';
import React, { memo, useCallback } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import './style.scss';

import { DeleteBinIcon, EditIcon, PlusIcon } from '@/assets/icons';
import IconWrap from '@/components/IconWrap';
import TableAdmin from '@/components/TableAdmin';
import { appRoutes } from '@/router/routes';
import productService from '@/services/product.service';
import { handleMessageError } from '@/util/handleMessageError';
import { ProductListResponseDTO } from '@/dto/responseDto/productList.dto';
import LoadingWrap from '@/components/LoadingWrap';
import LayoutContent from '@/layout/Content';

const ListSanPham = () => {
    const navigate = useNavigate();

    const { isLoading, data, refetch } = useQuery(['san-pham'], () => productService.getAll({ admin: true }), {
        enabled: true,
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    console.log('data', data);

    const { mutate: mutateDelete } = useMutation(['production'], (id: string) => productService.delete(id), {
        onSuccess: () => {
            refetch();
            notification.success({
                message: 'XÓA SẢN PHẨM THÀNH CÔNG',
            });
        },
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    const confirmDelete = useCallback(
        (id: string) => {
            Modal.confirm({
                title: 'XÁC NHẬN XÓA SẢN PHẨM',
                content: 'Bạn có chắc muốn xóa sản phầm này chứ?',
                onOk: () => {
                    mutateDelete(id);
                },
                okText: 'Xóa',
                cancelText: 'Đóng',
            });
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [mutateDelete],
    );

    const columns = [
        {
            title: 'Tên sản phẩm',
            dataIndex: 'name',
            align: 'left' as AlignType,
        },
        {
            title: 'Danh mục',
            dataIndex: 'categoryName',
            align: 'center' as AlignType,
        },
        {
            title: 'Giá bán',
            dataIndex: 'salesPrice',
            align: 'center' as AlignType,
            width: '152px',
        },
        {
            title: 'Tác vụ',
            render: (record: any) => (
                <Row justify="center">
                    <Space size={20}>
                        <IconWrap
                            className="pointer"
                            icon={<EditIcon />}
                            onClick={() => {
                                navigate(`${appRoutes.ADMIN.SERVICE.ITEM_UPDATE}/${record._id}`);
                            }}
                        />
                        <IconWrap
                            className="pointer"
                            onClick={() => confirmDelete(record._id)}
                            icon={<DeleteBinIcon />}
                        />
                    </Space>
                </Row>
            ),
            width: 150,
            fixed: 'right',
        },
    ];

    return (
        <LayoutContent
            className="p-floor"
            actionHeader={[
                {
                    url: `${appRoutes.ADMIN.SERVICE.ITEM_ADD}`,
                    title: 'THÊM MỚI',
                    icon: <PlusIcon />,
                },
            ]}
            title={`QUẢN LÝ SẢN PHẨM`}
        >
            <LoadingWrap isLoading={isLoading}>
                <div className="p-main">
                    <TableAdmin
                        columns={columns as any}
                        data={data?.data ?? ([] as any)}
                        rowKey="_id"
                        bordered
                        loading={isLoading}
                        className="table_floor"
                    />
                </div>
            </LoadingWrap>
        </LayoutContent>
    );
};
export default ListSanPham;
